import { render } from "./LicenseAlertPage.vue?vue&type=template&id=012b4a24&scoped=true"
import script from "./LicenseAlertPage.vue?vue&type=script&lang=js"
export * from "./LicenseAlertPage.vue?vue&type=script&lang=js"

import "./LicenseAlertPage.vue?vue&type=style&index=0&id=012b4a24&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012b4a24"]])

export default __exports__